import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=94e6bd0e&scoped=true&lang=pug&"
import script from "./ResetView.vue?vue&type=script&lang=js&"
export * from "./ResetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e6bd0e",
  null
  
)

/* custom blocks */
import block0 from "./ResetView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports